var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../../../strings/i18n';
import { cancelLimitIncreaseForm, closeButton, requestLimitIncrease } from '../../../../const/analytics';
import { Footer } from '../subcomponents';
var CreditLimitIncreaseFooter = function (_a) {
    var isPrimaryDisabled = _a.isPrimaryDisabled, isSecondaryDisabled = _a.isSecondaryDisabled, hasErrorOrSuccess = _a.hasErrorOrSuccess, fetchLimitIncrease = _a.fetchLimitIncrease, handleCancel = _a.handleCancel;
    var footerProps = {
        form: __assign(__assign({ primaryText: translate('button.requestIncrease'), handlePrimaryButton: fetchLimitIncrease, secondaryText: translate('button.cancel'), secondaryButtonType: 'ghost', handleSecondaryButton: handleCancel }, cancelLimitIncreaseForm), requestLimitIncrease),
        statusMessage: __assign({ primaryText: translate('button.close'), handlePrimaryButton: handleCancel }, closeButton)
    };
    return (_jsx(Footer, __assign({ isPrimaryDisabled: isPrimaryDisabled, isSecondaryDisabled: isSecondaryDisabled }, (hasErrorOrSuccess ? footerProps.statusMessage : footerProps.form))));
};
export default CreditLimitIncreaseFooter;
